import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { ModalLayout } from './parts/ModalLayout';
import { ModalHeader } from './parts/ModalHeader';
import { CallButton } from './parts/CallButton';
import { ModalContent } from './parts/ModalContent';
import { LayoutImage } from './parts/LayoutImage';
import { FlatsList } from './parts/FlatsList';
import { ExcursionBlock } from './parts/ExcursionBlock';
import { Loading } from './parts/Loading';
import { ErrorScreen } from './parts/ErrorScreen';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const LayoutModal = _ref => {
  let {
    onClose,
    onReset,
    trackTourClick,
    trackFlatCardClick,
    trackHeaderLinkClick,
    open,
    callButton,
    layoutImageUrl,
    layoutOffers,
    isLoading,
    favoriteButton
  } = _ref;
  return /*#__PURE__*/_jsx(ModalFullscreen, {
    onClose: onClose,
    open: open,
    theme: "white",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        onClose: onClose,
        onClick: trackHeaderLinkClick,
        title: layoutOffers === null || layoutOffers === void 0 ? void 0 : layoutOffers.title,
        description: layoutOffers === null || layoutOffers === void 0 ? void 0 : layoutOffers.offersDescription,
        url: layoutOffers === null || layoutOffers === void 0 ? void 0 : layoutOffers.offersDescriptionUrl
      }), !isLoading && layoutOffers && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(ModalContent, {
          children: [/*#__PURE__*/_jsx(LayoutImage, {
            url: layoutImageUrl
          }), /*#__PURE__*/_jsx(ExcursionBlock, {
            tourUrl: layoutOffers.tourUrl,
            onOpen: trackTourClick
          })]
        }), /*#__PURE__*/_jsx(FlatsList, {
          flats: layoutOffers.offers,
          favoriteButton: favoriteButton,
          onFlatCardClick: trackFlatCardClick
        }), /*#__PURE__*/_jsx(CallButton, {
          children: callButton
        })]
      }), isLoading && /*#__PURE__*/_jsx(Loading, {}), !isLoading && !layoutOffers && /*#__PURE__*/_jsx(ErrorScreen, {
        onReset: onReset
      })]
    })
  });
};